<template>
    <div class="musteri-makina-form" v-loading="loading">
        <el-form
                ref="mmForm"
                :model="form"
                :rules="rules"
                label-position="left"
                label-width="150px"
                align="left">
            <el-row class="musteri-makina-row">
                <el-form-item prop="makina_id" label="Makina Seçiniz">
                    <el-select v-model="form.makina_id">
                        <el-option v-for="m in makinaList" :value="m.id" :label="m.adi" :key="`${m.id}-makina`"/>
                    </el-select>
                </el-form-item>

                <el-divider/>

                <el-form-item prop="koku_id" label="Koku Seçiniz">
                    <el-select v-model="form.koku_id">
                        <el-option v-for="k in kokuList" :value="k.id" :label="k.adi" :key="`${k.id}-koku`"/>
                    </el-select>
                </el-form-item>

                <el-divider/>

                <el-form-item prop="baslangic_zamani" label="Baslangic">
                    <mak-date-picker v-model="form.baslangic_zamani"/>
                </el-form-item>

                <el-divider/>

                <el-form-item prop="yogunluk" label="Yoğunluk">
                    <el-input v-if="false" v-model="form.yogunluk" maxValue="100" minlength="1" type="number">
                        <span slot="prepend">%</span>
                    </el-input>

                    <el-slider
                            v-model="form.yogunluk"
                            show-stops
                            :step="5"
                            :min="0"
                            :max="100"
                            show-input>
                    </el-slider>
                </el-form-item>

                <el-divider/>

                <el-form-item prop="calisma_baslangic_saati" label="Calışma Saatleri">
                    <el-time-picker
                            is-range
                            v-model="timeValue"
                            range-separator="-"
                            start-placeholder="Başlangıç Zamanı"
                            end-placeholder="Bitiş Zamanı">
                    </el-time-picker>
                </el-form-item>

                <el-divider/>

                <el-form-item prop="calisma_gunleri" label="Calışma Günleri">
                    <el-checkbox
                            :indeterminate="isIndeterminate"
                            v-model="checkAll"
                            @change="handleCheckAllChange">Tüm Günler</el-checkbox>
                    <div style="margin: 15px 0;"></div>
                    <el-checkbox-group v-model="checkedGunler" @change="handleCheckedCitiesChange">
                        <el-checkbox label="1" key="1">Pazartesi</el-checkbox>
                        <el-checkbox label="2" key="2">Salı</el-checkbox>
                        <el-checkbox label="3" key="3">Carşamba</el-checkbox>
                        <el-checkbox label="4" key="4">Perşembe</el-checkbox>
                        <el-checkbox label="5" key="5">Cuma</el-checkbox>
                        <el-checkbox label="6" key="6">Cumartesi</el-checkbox>
                        <el-checkbox label="7" key="7">Pazar</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-divider/>

                <el-form-item label="Öngörülen Aylık Harcama">
                    <el-input v-model="onerilenAylikHarcama" readonly></el-input>
                </el-form-item>

                <el-form-item  prop="koku_ml" label="Koku Mililitre">
                    <el-select v-model="form.koku_ml">
                        <el-option v-for="(k, ind) in kokuMililiters" :value="k.value" :label="k.label" :key="`${ind}-koku-ml`"/>
                    </el-select>
                </el-form-item>

                <el-divider/>

                <el-form-item prop="tutar" label="Tutar">
                    <el-input v-model="form.tutar" placeholder="Tutar" type="number">
                        <span slot="prepend">₺</span>
                    </el-input>
                </el-form-item>

                <el-divider/>

                <el-form-item prop="not" label="Not">
                    <el-input v-model="form.not" placeholder="Not giriniz..." type="text" maxValue="255" minlength="1" />
                </el-form-item>

                <el-divider/>

                <el-form-item>
                    <el-button v-if="updateId" type="primary" icon="el-icon-refresh" @click="save">Güncelle</el-button>
                    <el-button v-else type="primary" icon="el-icon-plus" @click="save">Ekle</el-button>
                    <el-button type="warning" icon="el-icon-close" @click="$emit('close')">Vazgeç</el-button>
                </el-form-item>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import moment from 'moment';
    import MakDatePicker from '@/components/MakDatePicker.vue'
    import { kokuMililiters } from "@/common/enums";

    const tumGunler = ['1','2','3','4','5','6','7'];
    export default {
        name: 'musteri-makina-form',
        props: {
            updateId: {type: [Number, String, Boolean], default: false},
        },
        components: {MakDatePicker},
        data() {
            return {
                isIndeterminate: true,
                checkAll: false,
                checkedGunler: ['1','2','3','4','5'],
                timeValue: [
                    new Date(2020,1, 1, 8, 30),
                    new Date(2020,1, 1, 18, 30),
                ],
                kokuMililiters,
                process: {
                    makina: false,
                    koku: false,
                },
                form: {
                    musteri_id: null,
                    makina_id: null,
                    koku_id: null,
                    baslangic_zamani: null,
                    yogunluk: null,
                    koku_ml: 50,
                    tutar: null,
                    not: null,
                },
                rules: {
                    makina_id: [{required: true, message: 'Koku Makinası seçiniz', trigger: 'change'}],
                    koku_id: [{required: true, message: 'Koku seçiniz', trigger: 'change'}],
                    baslangic_zamani: [{required: true, message: 'Başlangıç zamanı seçiniz', trigger: 'change'}],
                    yogunluk: [{required: true, message: 'Yoğunluk seçiniz', trigger: 'change'}],
                    tutar: [{required: true, message: 'Tutar giriniz', trigger: 'change'}],
                },
                makinaList: [],
                kokuList: [],
            };
        },
        computed: {
            id() {
                return this.$route.params.id;
            },
            loading() {
                const {makina, koku} = this.process;
                return makina || koku;
            },
            gunler() {
                return this.checkedGunler.join(',');
            },
            onerilenAylikHarcama() {
                const { olcum_sure, olcum_yogunluk, olcum_harcanan } = this.secilenKoku;
                if (!olcum_harcanan || !olcum_sure || !olcum_yogunluk
                    || !this.checkedGunler.length) {
                    return;
                }
                const start = moment(this.timeValue[0]);
                const end = moment(this.timeValue[1]);
                const saat = end.diff(start, 'hours');
                const gun = this.checkedGunler.length;
                const yogunluk = this.form.yogunluk;

                const saatlikHarcama = olcum_harcanan / olcum_yogunluk / olcum_sure;
                const oneri = saatlikHarcama * saat * gun * yogunluk * 4; // 4 haftalik kullanim icin hesapla
                return `${Math.ceil(oneri / 5) * 5} ml`;
            },
            secilenKoku() {
                if (!this.form.koku_id) {
                    return {};
                }
                return this.kokuList.find(k => k.id === this.form.koku_id);
            }
        },
        methods: {
            save() {
                const emit = this.updateId ? 'update' : 'add';
                const form = Object.assign({}, this.form);
                form.calisma_baslangic_saati = moment(this.timeValue[0]).format('HH:' +
                    'mm:ss');
                form.calisma_bitis_saati = moment(this.timeValue[1]).format('HH:mm:ss');
                form.calisma_gunleri = this.gunler;
                this.$refs.mmForm.validate()
                    .then(() => {
                        this.$emit(emit, form);
                    });
            },
            reset() {
                this.$refs.mmForm.resetFields();
            },
            fetchMakina() {
                this.process.makina = true;
                this.$requests.Makina.getMakina(this.form)
                    .then((data) => {
                        this.makinaList = data;
                    })
                    .catch((e) => {
                        console.error('error fetching makina list', e);
                    })
                    .then(() => {
                        this.process.makina = false;
                    });
            },
            fetchMusteriMakina() {
                if (!this.updateId) {
                    return;
                }
                this.process.makina = true;
                this.$requests.MusteriMakina.getMusteriMakinaDetail(this.updateId)
                    .then((data) => {
                        this.form = {
                            musteri_id: data.musteri_id,
                            makina_id: data.makina_id,
                            koku_id: data.koku_id,
                            baslangic_zamani: moment(data.baslangic_zamani),
                            yogunluk: parseInt(data.yogunluk),
                            koku_ml: data.koku_ml,
                            tutar: data.tutar,
                            not: data.not,
                        };
                        this.timeValue = [
                            moment(`2020-01-01 ${data.calisma_baslangic_saati}`),
                            moment(`2020-01-01 ${data.calisma_bitis_saati}`),
                        ];
                        this.checkedGunler = data.calisma_gunleri.split(',');
                    })
                    .catch((e) => {
                        console.error('error fetching makina list', e);
                    })
                    .then(() => {
                        this.process.makina = false;
                    });
            },
            fetchKoku() {
                this.process.koku = true;
                this.$requests.Koku.getKoku()
                    .then((data) => {
                        this.kokuList = data
                            .map((d) => {
                                d.olcum_harcanan = d.olcum_harcanan ? parseInt(d.olcum_harcanan) : null;
                                d.olcum_yogunluk = d.olcum_yogunluk ? parseInt(d.olcum_yogunluk) : null;
                                d.olcum_sure = d.olcum_sure ? parseInt(d.olcum_sure) : null;
                                return d;
                            });
                    })
                    .catch((e) => {
                        console.error('error', e);
                    })
                    .then(() => {
                        this.process.koku = false;
                    });
            },
            handleCheckAllChange(val) {
                this.checkedGunler = val ? tumGunler : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === tumGunler.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < tumGunler.length;
            },
        },
        mounted() {
            this.fetchKoku();
            this.fetchMakina();

            this.fetchMusteriMakina();
        },
        watch: {
            // visible() {
            //   if (this.visible && this.sirket) {
            //     this.form = Object.assign({}, this.sirket);
            //   }
            // },
        },
    }
</script>

<style lang="scss">
    .musteri-makina-form {


        .el-form-item__label {
            font-size: 16px;
            font-weight: bold;
        }

        .musteri-makina-row {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
        }

        .el-divider {
            margin: 0 0 25px 0;
            visibility: hidden;
        }

        .el-slider__runway {
            border: 1px solid #ccc;
        }
    }
</style>
